// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+Mono:wght@200&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Merriweather+Sans&family=Ubuntu:wght@500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1051;
    background: rgba(0, 0, 0, 0.5);
  }
  .loader svg {
    animation: icon-spin 2s infinite linear;
    position: absolute;
    top: 48%;
    left: 48%;
    color: #fff;
    font-size: 40px;
  }
  
  @keyframes icon-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }

.background{
  background-color: antiquewhite;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y:auto;
  overflow-x:hidden
}
.innerBackground{
  width: calc(100vw - 5px);
  height: calc(100vh - 5px);
  background-color: #200000;
  border-radius: 15px;
  display: flex;
  align-items: center;
  flex-direction:row;
  overflow:hidden;
}
.contentNav{
  width: calc(100vw - 110px);
  height: 96vh;
  background-color: #fff;
  border-radius: 20px 20px 20px 20px ;
  margin-right: 1%;
  overflow-y:hidden;
  position:absolute;
  left:100px;
}


.unauthorized_Error {
  width: 65%;
  margin: 0% auto 0;
  padding: 30px 5%;
  box-shadow: 0 0 9px #272b3a;
  border-radius: 5px;
  position: relative;
  top: 30vh;
  z-index: 9999;
}
.unauthorized_Error h1 {
  font-size: 3rem;
  color: #b93535;
}
.unauthorized_Error p{
  font-size: 1.6rem;
    text-align: center;
}
.form-label {
  margin-bottom: .2rem;
  font-size: .9rem;
  padding-left: 8px;
}

.css-3w2yfm-ValueContainer{
  height: 33px;
  overflow-y: scroll !important; 
}

.quiz .css-13cymwt-control, .css-1hb7zxy-IndicatorsContainer {
  height:40px;
}

.css-wsp0cs-MultiValueGeneric {
  overflow-x: hidden;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAIA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,aAAa;IACb,8BAA8B;EAChC;EACA;IAEE,uCAAuC;IACvC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAYA;IACE;MAEE,uBAAuB;IACzB;IACA;MAEE,yBAAyB;IAC3B;EACF;;AAEF;EACE,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf;AACF;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;;;AAGA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;IACf,kBAAkB;AACtB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Mono:wght@200&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Merriweather+Sans&family=Ubuntu:wght@500&display=swap');\n\n.loader {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    z-index: 1051;\n    background: rgba(0, 0, 0, 0.5);\n  }\n  .loader svg {\n    -webkit-animation: icon-spin 2s infinite linear;\n    animation: icon-spin 2s infinite linear;\n    position: absolute;\n    top: 48%;\n    left: 48%;\n    color: #fff;\n    font-size: 40px;\n  }\n  @-webkit-keyframes icon-spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(359deg);\n      transform: rotate(359deg);\n    }\n  }\n  \n  @keyframes icon-spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(359deg);\n      transform: rotate(359deg);\n    }\n  }\n\n.background{\n  background-color: antiquewhite;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow-y:auto;\n  overflow-x:hidden\n}\n.innerBackground{\n  width: calc(100vw - 5px);\n  height: calc(100vh - 5px);\n  background-color: #200000;\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  flex-direction:row;\n  overflow:hidden;\n}\n.contentNav{\n  width: calc(100vw - 110px);\n  height: 96vh;\n  background-color: #fff;\n  border-radius: 20px 20px 20px 20px ;\n  margin-right: 1%;\n  overflow-y:hidden;\n  position:absolute;\n  left:100px;\n}\n\n\n.unauthorized_Error {\n  width: 65%;\n  margin: 0% auto 0;\n  padding: 30px 5%;\n  box-shadow: 0 0 9px #272b3a;\n  border-radius: 5px;\n  position: relative;\n  top: 30vh;\n  z-index: 9999;\n}\n.unauthorized_Error h1 {\n  font-size: 3rem;\n  color: #b93535;\n}\n.unauthorized_Error p{\n  font-size: 1.6rem;\n    text-align: center;\n}\n.form-label {\n  margin-bottom: .2rem;\n  font-size: .9rem;\n  padding-left: 8px;\n}\n\n.css-3w2yfm-ValueContainer{\n  height: 33px;\n  overflow-y: scroll !important; \n}\n\n.quiz .css-13cymwt-control, .css-1hb7zxy-IndicatorsContainer {\n  height:40px;\n}\n\n.css-wsp0cs-MultiValueGeneric {\n  overflow-x: hidden;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
